import type { SbBlokData } from '@cinch-nx/data-storyblok'

import { Logo as DsLogo, type LogoBrand } from '../../design-system/logo'

/** Storyblok sends '' for a Single-Option left empty */
type Option<T> = T | ''

/**
 * Every brand the Logo draws. A Record, so a new LogoBrand fails to compile
 * until it is added here too.
 */
const logoBrands: Record<LogoBrand, true> = {
  cinch: true,
  Marshall: true,
  cinchLeasing: true,
  cinchServicing: true,
}

const isLogoBrand = (value: unknown): value is LogoBrand =>
  typeof value === 'string' &&
  Object.prototype.hasOwnProperty.call(logoBrands, value)

/** Fields of the DS_Logo blok; the brand values match the Logo prop */
export interface LogoBlok extends SbBlokData {
  /**
   * Required in Storyblok, but it can be empty, or hold a brand no longer in
   * the list, which would make the Logo throw, so only a known brand is drawn
   */
  brand?: Option<LogoBrand>
  /**
   * "On = Dark BG" in Figma, named like the DS_Button field. Left unset until
   * an editor turns it on, which the Logo's default treats as off.
   */
  onDarkBackground?: boolean
}

export const Logo = ({ brand, onDarkBackground }: LogoBlok) =>
  isLogoBrand(brand) ? (
    <DsLogo brand={brand} inverted={onDarkBackground} />
  ) : null
